import styled from 'styled-components';

export const SuccessContent = styled.div`
  text-align: center;
`;

export const SuccessActions = styled.div`
  margin-top: 16px;
`;

export const InputLabel = styled.label`
  font-weight: bold;
  font-size: 14px;
  display: block;
`;

export const InputError = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: bold;
  color: ${props => props.theme.colors.red};
`;
